// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3XFkJ","colMaxWidth":"Table_colMaxWidth__1zZrC"};